import { createFileRoute } from '@tanstack/react-router';

import { InterviewPage } from './-components/interview/interview-page';

export const Route = createFileRoute(
  '/participants/_authenticated/projects/$projectId/interview',
)({
  component: InterviewPageWrapper,
});

function InterviewPageWrapper() {
  const { projectId } = Route.useParams();
  return <InterviewPage projectId={projectId} />;
}
